export default "__VITE_ASSET__CDeaRekU__"